import * as tslib_1 from "tslib";
import React from 'react';
export var PerspectiveContext = React.createContext({
    isParallaxEnabled: false,
    getZeroPerspectiveContainer: function () { return null; },
    getScrollableContainer: function () { return null; },
    getContentContainer: function () { return null; },
});
// perspective provider magic:
export var PerspectiveProvider = function (_a) {
    var children = _a.children, zeroPerspectiveContainerId = _a.zeroPerspectiveContainerId, scrollableContainerId = _a.scrollableContainerId, contentContainerId = _a.contentContainerId, isParallaxEnabled = _a.isParallaxEnabled;
    if (typeof document === 'undefined') {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(PerspectiveContext.Provider, { value: {
            isParallaxEnabled: isParallaxEnabled,
            getZeroPerspectiveContainer: function () {
                return document.getElementById(zeroPerspectiveContainerId);
            },
            getScrollableContainer: function () {
                return scrollableContainerId
                    ? document.getElementById(scrollableContainerId)
                    : null;
            },
            getContentContainer: function () { return document.getElementById(contentContainerId); },
        } }, children));
};
// HOC for convenience...
export var withPerspectiveContext = function (Component) { return function (props) {
    return (React.createElement(PerspectiveContext.Consumer, null, function (perspectiveProps) { return (React.createElement(Component, tslib_1.__assign({}, perspectiveProps, props))); }));
}; };
//# sourceMappingURL=PerspectiveContext.js.map